import styled from '@emotion/styled';
import { AllowedColors, Button, colors, Modal, Text } from '@innovationdepartment/proxima-ui';
import { HELLO_EMAIL } from 'constants/emails';
import ButtonGroup from 'ui/ButtonGroup';
import CancelPlanModalContactCS from './CancelPlanModal.ContactCS';

const Wrapper = styled.div`
  width: 400px;
  margin-bottom: 24px;

  & + * > .proxima-button {
    height: 36px;
  }
`;

const CancelPlanModalView: React.FC<{
  open: boolean;
  onClose: () => void;
  onAccept: () => void;
}> = (props) => {
  return <CancelPlanModalContactCS {...props} />;
  /* disabled for the time being */
  const { open, onClose, onAccept } = props;
  return (
    <Modal title="Are you sure you want to cancel?" open={open} onClose={onClose}>
      <Wrapper>
        <Text variant="body2" color="neutral80">
          Without an active plan, you may lose access to key features and functionalities that are
          essential to managing your brand effectively. Certain tools, integrations, and services
          may become limited or unavailable.
          <br />
          <br />
          You can always resubscribe later, but we recommend keeping your subscription active to
          maintain full access.
          <br />
          <br />
          Need help? Contact our support team at <a href={`mailto:${HELLO_EMAIL}`}>{HELLO_EMAIL}</a>
          .
        </Text>
      </Wrapper>
      <ButtonGroup>
        <Button
          size="small"
          label="Go back"
          onClick={onClose}
          variant="outlined"
          color="secondary"
        />
        <Button
          overrideColors={{
            backgroundColor: colors.red50,
            textColor: 'white' as AllowedColors,
          }}
          className="proxima-button"
          variant="contained"
          size="small"
          label="Cancel plan"
          onClick={onAccept}
        />
      </ButtonGroup>
    </Modal>
  );
};

export default CancelPlanModalView;
